
import React, { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Calendar, Filter } from "lucide-react";
import ActivityFeed from "@/components/dashboard/ActivityFeed";
import { 
  Select, 
  SelectContent, 
  SelectItem, 
  SelectTrigger, 
  SelectValue 
} from "@/components/ui/select";

const ActivityHistoryPage: React.FC = () => {
  const [selectedStaff, setSelectedStaff] = useState<string | undefined>(undefined);
  const [activityType, setActivityType] = useState<string | undefined>(undefined);
  const [timeFrame, setTimeFrame] = useState("all");
  
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-xl font-bold flex items-center gap-2">
          <Calendar className="h-5 w-5" />
          AI Staff Activity History
        </h1>
      </div>
      
      <Card className="shadow-sm">
        <CardHeader>
          <CardTitle className="text-lg">Filters</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="space-y-2">
              <label className="text-sm font-medium">AI Staff</label>
              <Select value={selectedStaff} onValueChange={setSelectedStaff}>
                <SelectTrigger>
                  <SelectValue placeholder="All AI Staff" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">All AI Staff</SelectItem>
                  <SelectItem value="1">Morgan (Marketing)</SelectItem>
                </SelectContent>
              </Select>
            </div>
            
            <div className="space-y-2">
              <label className="text-sm font-medium">Activity Type</label>
              <Select value={activityType} onValueChange={setActivityType}>
                <SelectTrigger>
                  <SelectValue placeholder="All Activities" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">All Activities</SelectItem>
                  <SelectItem value="slack_command">Slack Commands</SelectItem>
                  <SelectItem value="slack_mention">Slack Mentions</SelectItem>
                  <SelectItem value="response_generated">Generated Responses</SelectItem>
                  <SelectItem value="error">Errors</SelectItem>
                </SelectContent>
              </Select>
            </div>
            
            <div className="space-y-2">
              <label className="text-sm font-medium">Time Frame</label>
              <Select value={timeFrame} onValueChange={setTimeFrame}>
                <SelectTrigger>
                  <SelectValue placeholder="All Time" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">All Time</SelectItem>
                  <SelectItem value="today">Today</SelectItem>
                  <SelectItem value="week">This Week</SelectItem>
                  <SelectItem value="month">This Month</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Tabs defaultValue="all" className="space-y-4">
        <TabsList>
          <TabsTrigger value="all">All Activities</TabsTrigger>
          <TabsTrigger value="slack">Slack</TabsTrigger>
          <TabsTrigger value="api">API Requests</TabsTrigger>
          <TabsTrigger value="errors">Errors</TabsTrigger>
        </TabsList>
        
        <TabsContent value="all" className="space-y-4">
          <ActivityFeed limit={30} aiStaffId={selectedStaff === "all" ? undefined : selectedStaff} />
        </TabsContent>
        
        <TabsContent value="slack" className="space-y-4">
          <ActivityFeed 
            limit={30} 
            aiStaffId={selectedStaff === "all" ? undefined : selectedStaff} 
          />
        </TabsContent>
        
        <TabsContent value="api" className="space-y-4">
          <ActivityFeed 
            limit={30} 
            aiStaffId={selectedStaff === "all" ? undefined : selectedStaff} 
          />
        </TabsContent>
        
        <TabsContent value="errors" className="space-y-4">
          <ActivityFeed 
            limit={30} 
            aiStaffId={selectedStaff === "all" ? undefined : selectedStaff} 
          />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ActivityHistoryPage;
